const DEFAULT_DURATION = 0.5

const animatedFadeIn = {
  variants: {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: { duration: DEFAULT_DURATION, ease: 'easeInOut' },
}

const animatedScaleIn = {
  variants: {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: { duration: 2, delay: 0.5, ease: 'easeInOut' },
}

const animatedFadeUp = {
  variants: {
    hidden: { opacity: 0, y: '100%' },
    visible: { opacity: 1, y: 0 },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: { duration: DEFAULT_DURATION, ease: 'easeInOut', delay: 0.3 },
}

const animatedFadeDown = {
  variants: {
    hidden: { opacity: 0, y: '-100%' },
    visible: { opacity: 1, y: 0 },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: { duration: DEFAULT_DURATION, ease: 'easeInOut', delay: 0.3 },
}

const animatedFadeLeft = {
  variants: {
    hidden: { opacity: 0, x: '100%' },
    visible: { opacity: 1, x: 0 },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: { duration: DEFAULT_DURATION, ease: 'easeInOut', delay: 0.3 },
}

export { animatedFadeIn, animatedScaleIn, animatedFadeUp, animatedFadeDown, animatedFadeLeft }
